import { toast } from '@econsult/econsult-ui/dist/components/Toast';
import { ErrorToast } from 'components/Toast';
import React, { Dispatch } from 'react';
import request from 'superagent';
import { STRINGS } from '../../config';

const {
  SUMMARISER: { HOST },
  REDUCERS: {
    TRANSCRIPTION: { ADD_TRANSCRIPTIONS, DELETE_TRANSCRIPTION },
  },
} = STRINGS;

export async function fetchTranscripts(dispatch: Dispatch<unknown>): Promise<void> {
  try {
    const response = await request.get(`${HOST}/generate/transcripts`).withCredentials();
    const transcripts = response.body;
    dispatch({ type: ADD_TRANSCRIPTIONS, payload: transcripts });
  } catch (error) {
    toast.error(
      React.createElement(ErrorToast, {
        message: 'Sorry, we could not process your request. Please try again.',
      }),
      {
        autoClose: 12000,
        pauseOnHover: true,
        hideProgressBar: false,
        closeOnClick: true,
        icon: false,
      },
    );
  }
}

export async function deleteTranscript(id: string, dispatch: Dispatch<unknown>): Promise<void> {
  try {
    await request.delete(`${HOST}/generate/transcripts/${id}`).withCredentials();
    dispatch({ type: DELETE_TRANSCRIPTION, payload: id });
  } catch (error) {
    toast.error(
      React.createElement(ErrorToast, {
        message: 'Sorry, we could not process your request. Please try again.',
      }),
      {
        autoClose: 12000,
        pauseOnHover: true,
        hideProgressBar: false,
        closeOnClick: true,
        icon: false,
      },
    );
  }
}
